import { getApi } from "../../../common/http/axiosExtensions";
import {
  apiCallBegan,
  apiCallSuccess,
  customerSignoutCompleted,
  routeChangeBegan,
  uiNotificationSent,
} from "../actionUtils";
import { General } from "../../../common/constants";
import { isEmpty } from "../../../common/utils";
import config from "../../../config.json";
import { startLoading, stopLoading } from "../../reducers/appService";
import { doRefreshToken } from "../../reducers/accountService";
import { Copy } from "../../../common/copy";

const api =
  ({ dispatch, getState }) =>
  (next) =>
  async (action) => {
    const onTokenRefresh = ({ accessToken, refreshToken }) => {
      dispatch(
        doRefreshToken({
          accessToken,
          refreshToken,
        })
      );
    };

    const onSignInExpired = () => {
      dispatch(customerSignoutCompleted());
      dispatch(routeChangeBegan({ intent: "logout" }));
    };

    if (action.type !== apiCallBegan.type) {
      return next(action);
    }

    dispatch(startLoading());

    const {
      baseUrl,
      url,
      method,
      data,
      accessToken,
      refreshToken,
      headers,
      onSuccess,
      onStart,
      onError,
      uiSuccessMessage,
    } = action.payload;

    try {
      if (onStart) {
        dispatch({
          type: onStart,
        });
      }

      next(action);

      const response = await getApi({
        baseUrl,
        onTokenRefresh,
        onSignInExpired,
      }).request({
        url,
        headers,
        method,
        data,
        meta: {
          accessToken,
          refreshToken,
        },
      });

      //General
      dispatch(apiCallSuccess(response.data));

      if (url === config.accounts.logoutUrl) {
        dispatch(
          routeChangeBegan({
            intent: "logout",
          })
        );
      }

      if (!isEmpty(uiSuccessMessage)) {
        let messagePayload = {
          success: true,
          userFriendlyMessage: uiSuccessMessage,
        };

        dispatch(uiNotificationSent(messagePayload));
      }
      //Specific
      if (onSuccess) {
        dispatch({
          type: onSuccess,
          payload: response.data,
        });
      }
    } catch (error) {
      let messagePayload = {
        statusCode: error.response?.status || "",
        message: error.message,
        errorCode: error.response?.data?.code || "",
        userFriendlyMessage:
          error.response?.data?.description || Copy.Common.ErrorMessage,
      };

      //logService.log(JSON.stringify(errorPayload));
      //General
      if (url !== config.accounts.refreshTokenUrl) {
        dispatch(uiNotificationSent(messagePayload));
      }
      //Specific
      if (onError) {
        dispatch({
          type: onError,
          payload: messagePayload,
        });
      }
    }

    dispatch(stopLoading());
  };
export default api;
